/**
 * Ubicación del navegador para el ponche del técnico (tracking de campo).
 *
 * NUNCA bloquea ni lanza: si el navegador no soporta geolocalización, el técnico
 * la niega, o expira, devuelve `null` y el ponche procede igual (ubicación nula).
 */

export interface BrowserCoords {
  lat: number;
  lng: number;
}

/** Timeout de la captura (ms). Corto: el ponche no debe quedarse esperando. */
const GEO_TIMEOUT_MS = 8000;

/**
 * Tope DURO de la espera, contado desde que se pide. Hace falta además del
 * `timeout` de arriba: ese lo cuenta el navegador recién cuando hay permiso, y
 * con el permiso PREGUNTANDO (el técnico no tocó ni "Permitir" ni "Bloquear")
 * no se llamaba a ningún callback y el ponche quedaba colgado para siempre.
 */
const TOPE_DURO_MS = GEO_TIMEOUT_MS + 2000;

export function getBrowserLocation(): Promise<BrowserCoords | null> {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    let resuelto = false;
    const terminar = (valor: BrowserCoords | null) => {
      if (resuelto) return; // lo que llegue después del tope no cambia nada
      resuelto = true;
      clearTimeout(tope);
      resolve(valor);
    };
    const tope = setTimeout(() => terminar(null), TOPE_DURO_MS);
    navigator.geolocation.getCurrentPosition(
      (pos) => terminar({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => terminar(null), // negada / error: seguimos sin ubicación
      { enableHighAccuracy: true, timeout: GEO_TIMEOUT_MS, maximumAge: 30_000 },
    );
  });
}
